import { KlevuTypeOfRecord, KlevuTypeOfRequest, } from "../../index.js";
const defaultOptions = {
    id: "similar",
    limit: 5,
};
/**
 * Fetch similiar products based on list of ids
 *
 * @category RecommendationQuery
 * @param ids similiar to these ids or itemgroupids
 * @param options
 * @returns
 */
export function similarProducts(ids, options, ...modifiers) {
    const params = Object.assign(Object.assign({}, defaultOptions), options);
    return {
        klevuFunctionId: "recommendation",
        modifiers,
        queries: [
            {
                id: params.id,
                typeOfRequest: KlevuTypeOfRequest.SimilarProducts,
                settings: {
                    limit: params.limit,
                    excludeIds: ids.map((id) => ({
                        key: "itemGroupId",
                        value: id,
                    })),
                    context: {
                        recentObjects: [
                            {
                                typeOfRecord: KlevuTypeOfRecord.Product,
                                records: ids.map((id) => ({ id })),
                            },
                        ],
                    },
                    typeOfRecords: [KlevuTypeOfRecord.Product],
                },
            },
        ],
    };
}
